var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Storage, BinaryStorage } from '../lib/classes';
import { getDayNumber } from '../lib/utils/datetime/getDayNumber';
import { randomItem } from '../lib/utils/match/random';
import { BIN_FEATURE } from './const/features';
import { postApiRequest } from '../backend-api';
import { alignSlices } from '../components/Game/src/geometry/alignSlices';
var STORAGE_KEY = 'tudoku';
export var today = function () { return Number(new Date().toISOString().substr(0, 10).replace(/-/g, '')); };
export var WALL_POSTS = {
    GAME__INFO: 1,
    // нулей в начало можно добавлять сколько угодно
    NONE_POSTS: 0,
};
var jsonStorage = new Storage(STORAGE_KEY, {
    created: Date.now(),
    mute: false,
    maxScore: 0,
    maxScoreToday: 0,
    countGamesToday: 0,
    totalScore: 0,
    currentDate: today(),
    colorThemeId: IS_ULTRA ? 1 : randomItem([0, 1]),
    learned: false,
    data: null,
    slices: null,
    score: 0,
    countHints: 25,
    bonusDate: new Date().getDate(),
    bonusTime: Date.now(),
    lang: '',
    comboAnimations: true,
    cancelMove: false,
    cancelMoveCounter: 0,
    coins: 100,
    wallPostStatus: WALL_POSTS.NONE_POSTS,
    wallPostTime: 0,
    hintCounter: 0,
    usedCoinsCounter: 0,
    receivedCoinsCounter: 0,
    dailyBonusHistory: [getDayNumber(new Date()) - 1],
    dailyBonusReceivedDay: 0,
    purchaseTime: 0,
    rewardedTime: 0,
});
var currentStorageState = jsonStorage.get();
export function decodeData(arr) {
    return Array.isArray(arr) ? arr.map(function (i) { return ({ value: i }); }) : [];
}
export function decodeSlices(slices) {
    var result = [];
    if (Array.isArray(slices) && slices.length) {
        for (var i = 0; i < 3; i++) {
            var length_1 = slices[0];
            var sliceData = slices.slice(1, length_1 + 1);
            var gridSize = sliceData[0];
            var dataLength = Math.pow(gridSize, 2);
            var data = decodeData(sliceData.slice(1, dataLength + 1));
            var cellSize = 1;
            var pos = { x: 0, y: 0 };
            var move = { x: 0, y: 0 };
            var slice = { gridSize: gridSize, data: data, selected: false, hidden: false, pos: pos, move: move, cellSize: cellSize };
            if (sliceData.length > dataLength + 1)
                slice = __assign(__assign({}, slice), { hidden: true, shadow: sliceData.slice(dataLength + 1) });
            slices = slices.slice(length_1 + 1);
            result.push(slice);
        }
        alignSlices(result);
    }
    return result;
}
export function safeDecodeSlices(slices) {
    try {
        return decodeSlices(slices);
    }
    catch (_err) {
        return [];
    }
}
export function encodeData(arr) {
    return arr.map(function (i) { return (i.value === undefined ? 0 : Number(i.value)); });
}
export function encodeSlices(slices) {
    return slices
        .map(function (s) { return __spreadArray(__spreadArray([s.gridSize], encodeData(s.data), true), (s.shadow || []), true); })
        .reduce(function (acc, cur) { return __spreadArray(__spreadArray(__spreadArray([], acc, true), [cur.length], false), cur, true); }, []);
}
var binaryInitialState = __assign(__assign({}, currentStorageState), { data: encodeData(currentStorageState.data || []), slices: encodeSlices(currentStorageState.slices || []) });
var BIN_STORAGE_KEY = STORAGE_KEY + '-bin';
var appStorageBin = new BinaryStorage(BIN_STORAGE_KEY, binaryInitialState);
export var appStorage = BIN_FEATURE ? appStorageBin : jsonStorage;
if (DEVELOPMENT) {
    // @ts-ignore
    window['appStorage'] = appStorage;
    window['clearStorage'] = function () {
        postApiRequest('/clear', {}).then(function () {
            window.localStorage.removeItem(STORAGE_KEY);
            Object.keys(localStorage)
                .filter(function (key) { return /^vk-bridge__/.test(key); })
                .forEach(function (key) { return window.localStorage.removeItem(key); });
            location.reload();
        });
    };
}
